import React from "react";

import * as styles from "./styles";

export function ScoreText({ text }: { text?: string }) {
  if (typeof text === "undefined") {
    return null;
  }

  return (
    <p className={styles.container} data-testid="score-description">
      {text}
    </p>
  );
}
